export const inputDateStyles = {
  // Base input container styles
  container: {
    base: 'relative',
    disabled: 'pointer-events-none',
  },

  // Input field styles (shared between web and native)
  input: {
    base: 'font-text-semibold placeholder:color-black/30 h-full flex-1 bg-transparent px-6 py-4 pr-4 text-[0.875rem] tracking-[-0.28] outline-none',
    disabled: 'color-black/25 placeholder:color-black/10',
    center: 'w-full px-0 text-center',
  },

  // Text display styles (shared between web and native)
  text: {
    base: 'font-text-semibold',
    disabled: 'color-black/25',
    placeholder: 'color-black/30',
  },
} as const 